/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Files_TitleInputs */

const es_walkthrough_settings_files_title = /** @type {(inputs: Walkthrough_Settings_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de Archivos`)
};

const en_walkthrough_settings_files_title = /** @type {(inputs: Walkthrough_Settings_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Management`)
};

/**
* | output |
* | --- |
* | "File Management" |
*
* @param {Walkthrough_Settings_Files_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_files_title = /** @type {((inputs?: Walkthrough_Settings_Files_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Files_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_files_title(inputs)
	return en_walkthrough_settings_files_title(inputs)
});
export { walkthrough_settings_files_title as "walkthrough.settings_files_title" }